// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__2eXUv","tooltip":"Tooltip_tooltip__1K7qB","fadeIn":"Tooltip_fadeIn__3cIS_"};